import {
  ChangeDetectorRef,
  computed,
  ElementRef,
  Injectable,
  Signal,
  signal,
} from '@angular/core'
import { TScreenSize, TScreenType } from '../../models/utils.model'

interface ElementWidths {
  [key: string]: number
}

@Injectable({
  providedIn: 'root',
})
export class ResponsiveService {
  private breakpoints = {
    xs: '(max-width: 576px)',
    sm: '(min-width: 577px) and (max-width: 768px)',
    md: '(min-width: 769px) and (max-width: 960px)',
    lg: '(min-width: 961px) and (max-width: 1200px)',
    xl: '(min-width: 1201px)',
  }

  screenSize = signal<TScreenSize>('md')
  elementWidths = signal<ElementWidths>({})

  screenType: Signal<TScreenType> = computed(() => {
    const screenSize = this.screenSize()
    return screenSize === 'xs' || screenSize === 'sm' || screenSize === 'md'
      ? 'mobile'
      : 'desktop'
  })

  constructor() {
    this.detectScreenSize()
  }

  private detectScreenSize() {
    const updateScreenSize = () => {
      if (window.matchMedia(this.breakpoints.xs).matches) {
        this.screenSize.set('xs')
      } else if (window.matchMedia(this.breakpoints.sm).matches) {
        this.screenSize.set('sm')
      } else if (window.matchMedia(this.breakpoints.md).matches) {
        this.screenSize.set('md')
      } else if (window.matchMedia(this.breakpoints.lg).matches) {
        this.screenSize.set('lg')
      } else if (window.matchMedia(this.breakpoints.xl).matches) {
        this.screenSize.set('xl')
      }
    }

    updateScreenSize()
    window.addEventListener('resize', updateScreenSize)
  }

  trackElement(elementRef: ElementRef, elementId: string) {
    if (elementRef?.nativeElement) {
      const width = elementRef.nativeElement.offsetWidth

      this.elementWidths.update((widths) => ({
        ...widths,
        [elementId]: width,
      }))
    }
  }

  stopTracking(elementId: string) {
    if (this.elementWidths()[elementId]) {
      this.elementWidths.update((widths) => {
        const newWidths = { ...widths }
        delete newWidths[elementId]
        return newWidths
      })
    }
  }

  getElementWidth(elementId: string): number {
    return this.elementWidths()[elementId] || 0
  }

  public updateCardWidth(tableID: string, cdr: ChangeDetectorRef) {
    let cardWidth = null

    const tableWidth = this.getElementWidth(tableID)
    if (tableWidth && this.screenType() === 'mobile') {
      const padding = 32 // 16 * 2
      cardWidth = `${tableWidth - padding}px`
    } else {
      cardWidth = null
    }
    cdr.markForCheck()

    return cardWidth
  }
}
